'use strict';

var React = require('react');

var SvgButtonCornerPillMajor = function SvgButtonCornerPillMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.25 5a7.25 7.25 0 0 0-7.25 7.25v3.5a.75.75 0 0 1-1.5 0v-3.5a8.75 8.75 0 0 1 8.75-8.75h3.5a.75.75 0 0 1 0 1.5h-3.5Z"
  }));
};
SvgButtonCornerPillMajor.displayName = "ButtonCornerPillMajor";

exports.SvgButtonCornerPillMajor = SvgButtonCornerPillMajor;
